import { isLocal } from '../config/appConfig';
import { useAppStore } from '../store/app/appStore';

const swPath = isLocal ? '/dev-sw.js?dev-sw' : '/sw.js';
const workerType: WorkerType = isLocal ? 'module' : 'classic';

export const initSW = () =>
  window.addEventListener('load', () => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    void navigator.serviceWorker.register(swPath, { type: workerType });

    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        const { loginRedirectUri } = useAppStore.getState();

        // Ensure a pending redirect is not lost if the page needs to reload before the user has logged in
        if (loginRedirectUri) {
          window.open(loginRedirectUri, '_self');
        } else {
          window.location.reload();
        }
      });
    }

    void navigator.serviceWorker.ready.then(async (registration) => {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        document.addEventListener(
          'visibilitychange',
          () => !document.hidden && registration.update(),
        );
      }
    });
  });

export const swPostMessage = async (data: string) => {
  const [reg] = await navigator.serviceWorker.getRegistrations();
  const serviceWorker = reg.active;

  if (!serviceWorker) {
    return;
  }
  serviceWorker.postMessage(data);
};
